import { z } from 'zod';
import { platformOutboxHealthSchema } from '../events/platform-domain-event.contract.js';
import { platformModuleActivationReasonSchema, } from '../capabilities/platform-capability.contract.js';
import { platformModuleIdSchema } from '../modules/platform-module-manifest.contract.js';
export const platformLivenessResponseSchema = z.strictObject({
    status: z.literal('ok'),
});
export const platformReadinessResponseSchema = z.strictObject({
    status: z.enum(['ready', 'degraded', 'not_ready']),
    database: z.enum(['ready', 'unavailable']),
    activationEpoch: z.number().int().nonnegative(),
    installedModuleIds: z.array(z.string()),
    deploymentEnabledModuleIds: z.array(z.string()),
    activeModuleIds: z.array(z.string()),
    quarantinedModules: z.array(z.strictObject({
        id: platformModuleIdSchema,
        reasons: z.array(platformModuleActivationReasonSchema).min(1),
    })),
});
export const platformWorkerReadinessResponseSchema = z.strictObject({
    status: z.enum(['ready', 'degraded', 'not_ready']),
    database: z.enum(['ready', 'unavailable']),
    outbox: platformOutboxHealthSchema.nullable(),
    reasons: z.array(z.enum([
        'database_unavailable',
        'dead_letters_present',
        'expired_leases_present',
        'pending_age_exceeded',
    ])),
});
//# sourceMappingURL=platform-health.contract.js.map